import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getReportLayers, setReportLayers } from "../../slices/app";
export const useReportLayers = () => {
    const dispatch = useDispatch();
    const value = useSelector(getReportLayers);
    const update = useCallback((updatedValue) => {
        dispatch(setReportLayers(updatedValue));
    }, [dispatch]);
    return [value, update];
};
